// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:768px){.child-border-2[data-v-ad2d2580]{width:calc(100% + 14px)}.child-border-1[data-v-ad2d2580]{width:calc(100% + 12px)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
